import { render } from "./LeadershipSectionComponent.vue?vue&type=template&id=163e9b63&scoped=true"
import script from "./LeadershipSectionComponent.vue?vue&type=script&lang=js"
export * from "./LeadershipSectionComponent.vue?vue&type=script&lang=js"

import "./LeadershipSectionComponent.vue?vue&type=style&index=0&id=163e9b63&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163e9b63"]])

export default __exports__